import React from 'react'
import _ from 'lodash'

class CarouselArrow extends React.PureComponent {
  constructor(props) {
    super(props)

    this.style = {}
    let orientation = _.includes(props.className, 'slick-prev') ? 'left' : 'right'
    let position = (props.itemCount / 2) * 30

    this.style[orientation] = `calc(50% - ${position}px)`
  }

  render() {
    return (
      <button
        { ...this.props }
        style={this.style}
        className={this.props.className + ' site-border-color'}>
      </button>
    )
  }
}

export default CarouselArrow;
